function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { assessCensusApi } from '@/api/enterprise';
import Commnt from '@/components/user/accessCommon';
import echarts from 'echarts';
export default {
  name: 'AssessStatistics',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    }
  },
  props: {
    searchBtn: {
      type: Boolean,
      default: false
    },
    planId: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    var _ref;
    return _ref = {
      pickerOptions: this.$pickerOptionsTimeEle,
      departmentList: [],
      periodOptions: Commnt.periodOption,
      type1: 0,
      statusOptions: Commnt.statusOptions,
      userList: [],
      colorList: ['#657899', '#6FE9EA', '#679AFA', '#FBB221', '#F67878', '#00BFFF', '#00FFFF', '#FFD700', '#FAF0E6', '#F0F8FF']
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "periodOptions", Commnt.periodOptions), "fromList", [{
      label: this.$t('toptable.all'),
      value: ''
    }, {
      label: this.$t('toptable.today'),
      value: 'today'
    }, {
      label: this.$t('toptable.yesterday'),
      value: 'yesterday'
    }, {
      label: this.$t('toptable.day7'),
      value: 'lately7'
    }, {
      label: this.$t('toptable.day30'),
      value: 'lately30'
    }, {
      label: this.$t('toptable.thismonth'),
      value: 'month'
    }, {
      label: this.$t('toptable.thisyear'),
      value: 'year'
    }]), "frameArray", [{
      name: this.$t('setting.selectdepartment'),
      id: ''
    }]), "userArray", [{
      label: this.$t('access.selectpersonnel'),
      value: ''
    }]), "tableData", []), "frame", []), "period", 2), "time", [this.$moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD'), this.$moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD')]), "date", this.$moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD') + '-' + this.$moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD')), "frame_id", ''), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "test_uid", ''), "total", 0), "totalNumber", 0.8), "height", 420), "styles1", {
      height: '570px',
      width: '100%'
    }), "optionData", {});
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    // 选择成员回调
    getSelectList: function getSelectList(data) {
      var testUid = [];
      data.forEach(function (item) {
        testUid.push(item.value);
      });
      this.test_uid = testUid;
      this.userList = data;
      this.getTableData();
    },
    changeMastart: function changeMastart(data) {
      var frame = [];
      data.forEach(function (value) {
        frame.push(value.id);
      });
      this.frame_id = frame;
      this.departmentList = data;
      this.getTableData();
    },
    setOptions: function setOptions() {
      this.fromList = [{
        label: this.$t('toptable.all'),
        value: ''
      }, {
        label: this.$t('toptable.today'),
        value: 'today'
      }, {
        label: this.$t('toptable.yesterday'),
        value: 'yesterday'
      }, {
        label: this.$t('toptable.day7'),
        value: 'lately7'
      }, {
        label: this.$t('toptable.day30'),
        value: 'lately30'
      }, {
        label: this.$t('toptable.thismonth'),
        value: 'month'
      }, {
        label: this.$t('toptable.thisyear'),
        value: 'year'
      }];
    },
    getTableData: function getTableData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                period: _this.period,
                time: _this.date,
                frame_id: _this.frame_id,
                test_uid: _this.test_uid,
                number: _this.planId,
                types: _this.type
              };
              _context.next = 3;
              return assessCensusApi(data);
            case 3:
              result = _context.sent;
              _this.tableData = result.data.score;
              _this.total = result.data.count;
              _this.init();
              _this.frame = result.data.frame ? result.data.frame : [];
              _this.frameArray = _this.frame;
              _this.frameArray.unshift({
                name: _this.$t('setting.selectdepartment'),
                id: ''
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    reset: function reset() {
      this.period = 2;
      this.time = [this.$moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD'), this.$moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD')];
      this.date = this.$moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD') + '-' + this.$moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD');
      this.frame_id = '';
      this.test_uid = '';
      this.planId = '';
      this.type = 2;
      this.departmentList = [];
      this.userList = [];
      this.getTableData();
    },
    handlePeriod: function handlePeriod(num) {
      this.period = num;
      this.frame_id = '';
      this.test_uid = '';
      if (num == 1) {
        this.time = [this.$moment().startOf('week').format('YYYY/MM/DD'), this.$moment().endOf('week').format('YYYY/MM/DD')];
      } else if (num == 2) {
        this.time = [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')];
      } else if (num == 5) {
        this.time = [this.$moment().startOf('quarter').format('YYYY/MM/DD'), this.$moment().endOf('quarter').format('YYYY/MM/DD')];
      } else if (num == 3) {
        this.time = [this.$moment().startOf('year').format('YYYY/MM/DD'), this.$moment().endOf('year').format('YYYY/MM/DD')];
      } else if (num == 4) {
        var m = new Date().getMonth() + 1;
        this.time = m < 7 ? [this.$moment().format('YYYY/01/01'), this.$moment().format('YYYY/06/30')] : [this.$moment().format('YYYY/07/01'), this.$moment().format('YYYY/12/31')];
      }
      this.date = this.time[0] + '-' + this.time[1];
      this.getTableData();
    },
    onchangeTime: function onchangeTime(e) {
      if (e === null) {
        this.time = '';
        this.date = '';
      } else {
        if (e[0] === e[1]) {
          var lastDate = this.$moment(e[0], 'YYYY/MM/DD').endOf('month').format('YYYY/MM/DD');
          this.time[1] = lastDate;
          this.date = e[0] + '-' + lastDate;
        } else {
          this.date = e[0] + '-' + e[1];
        }
      }
      this.getTableData();
    },
    init: function init() {
      var _this2 = this;
      this.optionData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function formatter(option) {
            return "".concat(option[0].name, "<br/>").concat(option[0].value, "\u4EBA");
          }
        },
        grid: {
          right: '0',
          bottom: 80
        },
        toolbox: {},
        xAxis: [{
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          data: []
        }, {
          position: 'bottom',
          offset: 30,
          axisLine: {
            show: false
          },
          nameTextStyle: {
            color: '#EEEEEE'
          },
          type: 'category',
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          data: []
        }],
        yAxis: [{
          type: 'value',
          position: 'left',
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            show: false
          }
        }],
        series: [{
          name: '',
          type: 'bar',
          itemStyle: {
            normal: {
              color: function color(params) {
                var colorList = _this2.colorList;
                return colorList[params.dataIndex];
              },
              label: {
                show: true,
                color: '#000000',
                position: 'top',
                formatter: function formatter(params) {
                  return _this2.total == 0 ? 0 : (params.value / _this2.total * 100).toFixed(2) + '%';
                }
              }
            }
          },
          data: []
        }]
      };
      var xAxisName = [];
      var xAxisCount = [];
      var seriesData = [];
      if (this.tableData.length > 0) {
        this.tableData.forEach(function (value) {
          xAxisName.push(value.name);
          xAxisCount.push(!_this2.test_uid ? value.count + _this2.$t('access.ren') : value.count + _this2.$t('access.ci'));
          seriesData.push(value.count);
        });
        this.optionData.xAxis[0].data = xAxisName;
        this.optionData.xAxis[1].data = xAxisCount;
        this.optionData.series[0].data = seriesData;
      }
      this.myChart = echarts.init(document.getElementById('statistics-con'));
      var option = null;
      option = this.optionData;
      // 基于准备好的dom，初始化echarts实例
      this.myChart.setOption(option, true);
    },
    handleFrame: function handleFrame(num) {
      var _this3 = this;
      this.frame_id = num;
      this.test_uid = '';
      this.userArray = [{
        label: this.$t('access.selectpersonnel'),
        value: ''
      }];
      if (num != '') {
        var index = this.getFindIndex(this.frame, 'id', num);
        this.frame[index].user.forEach(function (value) {
          _this3.userArray.push({
            label: value.card.name,
            value: value.id
          });
        });
      }
      this.getTableData();
    },
    handleTest: function handleTest(num) {
      this.test_uid = num;
      this.getTableData();
    },
    getFindIndex: function getFindIndex(arr, name, number) {
      var index = arr.findIndex(function (item) {
        return item[name] == number;
      });
      return index;
    }
  }
};